/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FleetAuthenticateLogoutType } from './FleetAuthenticateLogoutType';
import {
    FleetAuthenticateLogoutTypeFromJSON,
    FleetAuthenticateLogoutTypeFromJSONTyped,
    FleetAuthenticateLogoutTypeToJSON,
    FleetAuthenticateLogoutTypeToJSONTyped,
} from './FleetAuthenticateLogoutType';
import type { FleetAuthenticateType } from './FleetAuthenticateType';
import {
    FleetAuthenticateTypeFromJSON,
    FleetAuthenticateTypeFromJSONTyped,
    FleetAuthenticateTypeToJSON,
    FleetAuthenticateTypeToJSONTyped,
} from './FleetAuthenticateType';
import type { FleetAuthenticateConnectionStatus } from './FleetAuthenticateConnectionStatus';
import {
    FleetAuthenticateConnectionStatusFromJSON,
    FleetAuthenticateConnectionStatusFromJSONTyped,
    FleetAuthenticateConnectionStatusToJSON,
    FleetAuthenticateConnectionStatusToJSONTyped,
} from './FleetAuthenticateConnectionStatus';

/**
 * 
 * @export
 * @interface FleetAuthenticateEventCreate
 */
export interface FleetAuthenticateEventCreate {
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEventCreate
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof FleetAuthenticateEventCreate
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEventCreate
     */
    periodId: string;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEventCreate
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticateEventCreate
     */
    userId: string;
    /**
     * 
     * @type {FleetAuthenticateType}
     * @memberof FleetAuthenticateEventCreate
     */
    authenticateType: FleetAuthenticateType;
    /**
     * 
     * @type {FleetAuthenticateConnectionStatus}
     * @memberof FleetAuthenticateEventCreate
     */
    connectionStatus?: FleetAuthenticateConnectionStatus | null;
    /**
     * 
     * @type {FleetAuthenticateLogoutType}
     * @memberof FleetAuthenticateEventCreate
     */
    logoutType?: FleetAuthenticateLogoutType | null;
}



/**
 * Check if a given object implements the FleetAuthenticateEventCreate interface.
 */
export function instanceOfFleetAuthenticateEventCreate(value: object): value is FleetAuthenticateEventCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('periodId' in value) || value['periodId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('authenticateType' in value) || value['authenticateType'] === undefined) return false;
    return true;
}

export function FleetAuthenticateEventCreateFromJSON(json: any): FleetAuthenticateEventCreate {
    return FleetAuthenticateEventCreateFromJSONTyped(json, false);
}

export function FleetAuthenticateEventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticateEventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'periodId': json['periodId'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'],
        'authenticateType': FleetAuthenticateTypeFromJSON(json['authenticateType']),
        'connectionStatus': json['connectionStatus'] == null ? undefined : FleetAuthenticateConnectionStatusFromJSON(json['connectionStatus']),
        'logoutType': json['logoutType'] == null ? undefined : FleetAuthenticateLogoutTypeFromJSON(json['logoutType']),
    };
}

export function FleetAuthenticateEventCreateToJSON(json: any): FleetAuthenticateEventCreate {
    return FleetAuthenticateEventCreateToJSONTyped(json, false);
}

export function FleetAuthenticateEventCreateToJSONTyped(value?: FleetAuthenticateEventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'periodId': value['periodId'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'authenticateType': FleetAuthenticateTypeToJSON(value['authenticateType']),
        'connectionStatus': FleetAuthenticateConnectionStatusToJSON(value['connectionStatus']),
        'logoutType': FleetAuthenticateLogoutTypeToJSON(value['logoutType']),
    };
}

